import React from 'react';
import { formatText } from '../../utils/formatters';

const WidgetText = ({ textResult, prompt }) => {
  return (
    <div 
      className="text-content text-gray-700"
      dangerouslySetInnerHTML={{ __html: formatText(textResult, prompt) }}
    />
  );
};

export default WidgetText;